import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '@core/constants/storage-keys';
import { Usuario } from '@domain/usuario/usuario';

@Injectable({ providedIn: 'root' })
export class AuthStorageRepository {
  constructor() {}

  getUsuario(): Usuario | null {
    const usuarioArmazenado = localStorage.getItem(STORAGE_KEYS.USER);
    if (usuarioArmazenado?.trim()) {
      return JSON.parse(usuarioArmazenado);
    }

    return null;
  }

  saveUsuario(usuario: Usuario): void {
    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(usuario));
  }

  logout(): void {
    localStorage.removeItem('app_egtec_auth_user');
  }
}
